// Native details remains usable without JavaScript; enhance dismissal and focus only.
if (!customElements.get('w2w-confidence')) {
  customElements.define('w2w-confidence', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      const details = this.querySelector('details');
      const trigger = this.querySelector('summary');
      const close = (restoreFocus = false) => {
        if (!details.open) return;
        details.open = false;
        if (restoreFocus) trigger.focus({ preventScroll: true });
      };
      this.querySelector('button').addEventListener('click', () => close(true), options);
      this.addEventListener('keydown', event => {
        if (event.key === 'Escape' && details.open) {
          event.preventDefault();
          event.stopPropagation();
          close(true);
        }
      }, options);
      document.addEventListener('pointerdown', event => {
        if (!this.contains(event.target)) close();
      }, options);
      this.addEventListener('focusout', event => {
        if (event.relatedTarget && !this.contains(event.relatedTarget)) close();
      }, options);
      this.setAttribute('data-enhanced', '');
    }
    disconnectedCallback() {
      this.controller?.abort();
    }
  });
}
